import { CommonModule } from '@angular/common';
import { Component, inject, Input, SimpleChanges } from '@angular/core';
import { DataCore, filterData, grado, GradoItem, asignaturas } from '../../../interface/data-core';
import { environment } from '../../../../environments/environment';
import { CargarConfService } from '../../../services/cargar-conf.service';
import { agruparAsignaturas, ASIGNATURA_COMPONENT_ID, FILTER_LABEL_GRADO, GRADOS_COMPONENT_ID, limitScroll, LISTADO_DINAMICO_ID, onAddClass, onScrollComponente } from '../../../utils/generales';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-grados',
    imports: [CommonModule],
    templateUrl: './grados.component.html',
    styleUrl: './grados.component.css'
})
export class GradosComponent {

    @Input() public dataGrados?: grado[] = [];
    @Input() public filtroSelecionados?: filterData;

    private tempDataGrados: grado[] = [];//variable temporal para almacenar los grados originales

    public _conf = inject(CargarConfService);

    public grados_label: string = environment.grados_label || 'Grados'; // Usar el label del environment o un valor por defecto
    public grados_list: GradoItem[] = [];
    public loggedIn = this._conf._auth.isAuthenticated();

    constructor() {
    }

    ngOnInit() {
        this.init();

    }

    ngOnChanges(changes: SimpleChanges) {
        this.init();

    }

    init() {

        const currentFilters = this._conf.getCurrentFilters();

        // Aquí podrías inicializar algo si es necesario
        this.tempDataGrados = this.dataGrados ? [...this.dataGrados] : [];
        if (currentFilters.class_asignatura) {
            const asignaturas_list = agruparAsignaturas(this._conf.dataGlobal?.asignaturas ?? []);
            const asignatura = asignaturas_list.find(a => a.clase === currentFilters.class_asignatura);

            if (asignatura?.listGrados?.length) {
                this.tempDataGrados = this.tempDataGrados.filter(grado => asignatura.listGrados!.includes(grado.i));
            }
        }
        this.grados_list = [];
        if (this.dataGrados) {

            this.grados_list = this.tempDataGrados.map((grado) => {
                return {
                    id: grado.i,
                    label: grado.n,
                    icon: null, // Aquí podrías asignar un icono si es necesario
                    clase: `${grado.class}${!this.loggedIn ? ' d_inactiveicons' : ''}`,
                    title: grado.n, // Título opcional para tooltip o similar
                    action: () => {
                        if (!this.loggedIn) {
                            return;
                        }
                        // Acción al hacer clic en el grado
                        onAddClass(LISTADO_DINAMICO_ID, 'onHide');

                        if (grado.i) {
                            onAddClass(GRADOS_COMPONENT_ID, 'onHide').then(() => {
                                this._conf.updateFilterField(FILTER_LABEL_GRADO as keyof filterData, grado.i ?? null);
                                setTimeout(() => {

                                    onScrollComponente(ASIGNATURA_COMPONENT_ID);
                                    onAddClass(ASIGNATURA_COMPONENT_ID, 'd_firstsection')
                                }, 50);
                            });
                        }
                    }
                } as GradoItem;
            });

        }

        console.debug('Lista de asignaturas agrupadas', this.grados_list);

        console.debug('Asignaturas de origen', this._conf.dataGlobal?.asignaturas, this.filtroSelecionados)


        if (this.grados_list.length === 1 && !this.filtroSelecionados?.grado && currentFilters.class_asignatura) {
            let [grado] = [...this.grados_list]
            if (grado?.action)
                grado.action()
        }
    }

}
